module.exports = __webpack_public_path__ + "img/brodcast-inavi.2f95f528.jpg";